import { LISTAR_PONTOS_EMBARQUE } from '../../actions/types'

const initialState = []

export default function reducerPontosEmbarque(state = initialState, action = {}) {
  switch (action.type) {
    case LISTAR_PONTOS_EMBARQUE: {
      const pontos = action.payload.data
      return pontos || []
    }
    default:
      return state
  }
}
